import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { update } from './store/features/reloadSlice';
import store from './store/store';

// Extract session_id from URL query parameters
function getSessionIdFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('session_id') || null;
}

// Wait for DOM to be ready
function initWidget() {
  const element = document.getElementById('embedded_forms_widget');

  if (element && element instanceof HTMLElement) {
    try {
      const sessionId = getSessionIdFromURL();
      console.log('🔵 index.js: Extracted sessionId from URL:', sessionId);
      const root = ReactDOM.createRoot(element);
      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <App form={element?.dataset?.form} sessionId={sessionId} />
          </Provider>
        </React.StrictMode>,
      );
    } catch (error) {
      console.error('Embedded Forms Widget: Error mounting:', error);
    }
  } else {
    console.error(
      'Embedded Forms Widget: Could not find element with id="embedded_forms_widget" or element is not a valid DOM element',
    );
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWidget);
} else {
  // DOM already ready
  initWidget();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
// const configuration = {
//   onUpdate: registration => {
//     if (registration && registration.waiting) {
//       store.dispatch(update(registration));
//     }
//   },
// };

// serviceWorkerRegistration.register(configuration);
